import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  private activeRequests = 0;

  show = () => {
    if (this.activeRequests === 0 && !this.loadingSubject.value) {
      this.loadingSubject.next(true);
    }
    this.activeRequests++;
  }

  hide = () => {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    if (this.activeRequests === 0 && this.loadingSubject.value) {
      this.loadingSubject.next(false);
    }
  }
}
